/**
 * @title membership-helper.js: utility module
 * @description Helper for membership specific modules
 * @author kmedz
 */
define(['membershipData', 'addressForm', 'address', 'addressVerification', 'accountHelper'], function(membershipData, addressForm, address, addressVerification, accountHelper) {
  let MembershipHelper = {
    /**
     * Initializes the module with the specific membership type, which is
     * defined in MembershipApplication_PreloadData.jspf
     * @return {void} [description]
     */
    init: function() {
      this.membershipType = membershipType;

      if (typeof totalFee !== 'undefined') {
        this.totalFee = totalFee;
      }
      if (typeof membershipFee !== 'undefined') {
        this.membershipFee = membershipFee;
      }
      
      $('#postalcode').val('');
      $('#businessZipCode').val('');
    },
    isQuickMembership: false,
    /**
     * When we create an affiliate form we need to populate things like
     * the date of birth selectors, do the fancy bing zip thing, etc.
     * @param {jQuery.Element} form - The form containing the inputs we want
     *                              to modify
     * @return {void}
     */
    formWizBangs: function(form) {
      // 5.2 Populate the appropriate inputs. Do the fancy masking stuff.
      // Date of birth inputs
      this.dobPopulate(`#${form.attr('id')}`, 100);
      
      /** Membership DOB month field numeric restriction and appending 0 before 1-9 value */
      form.find('[name=month],[name=household_month],[name=householdDobMonth],[name=dobmonth],[name=MembershipCrmCallerInfo_dobEditMonth]').on({
    	  'focusout' : function(event) {MembershipHelper.prependZero(event);}    	  
      });
      
      /** Membership DOB day field numeric restriction and appending 0 before 1-9 value */
      form.find('[name=day],[name=household_day],[name=householdDobDay],[name=dobday],[name=MembershipCrmCallerInfo_dobEditDay]').on({
    	  'focusout' : function(event) {MembershipHelper.prependZero(event);}
      });      

      /** Membership DOB year field numeric restriction */
      form.find('[name=year],[name=household_year],[name=householdDobYear],[name=dobyear],[name=MembershipCrmCallerInfo_dobEditYear]').on({
      });
                  
      var isDeriveCityStateEnabled = costcoStoreFeatures.DERIVE_CITY_STATE_FROM_ZIP_POSTAL_CODE_ENABLED 
			&& $('input[name=deriveCityStateEnabled]') && $('input[name=deriveCityStateEnabled]').val() === "true";
       // Populate state select box if the DERIVE_CITY_STATE_FROM_ZIP_POSTAL_CODE_ENABLED feature is not enabled.
      if (form.find('.state-select').length) {
    	  let stateProvList = this.getStateProvJson();
    	  let stateOptions = this.getStateOptions(stateProvList);
    	  let $selects = isDeriveCityStateEnabled ? form.find('.state-select') : form.find('.state-select').append(stateOptions);
    	  $selects.each(function(i, select) {
          // If the select has a readonly attribute, disable all options
          // except the currently selected option.
          if ($(select).attr('readonly')) { // will return "readonly"
            $(select).find('option').attr('disabled', 'disabled');
          }
        });
      }
      // Bing City State autocomplete
      // Personal information
      form.find('[name=postalcode]').on('input', function(event) {
        let value = $(event.currentTarget).val();

        if (value != null && value != '' && value.trim().length > 4) {
        	let region = COSTCO.util.isUsOrCaZipCode();
			if($('#isGeocodeService').val() != "true" && value != null && value != "" && value.trim().length > 4){
				this.bingCityState(event.currentTarget, '[name=city]', '[name=state]');
			}
			if($('#isGeocodeService').val() === "true" && value != null && value != "" && value.trim().length === value.length){
				if (region && COSTCO.util.POSTAL_CODE_REGEX_US.test(value.trim())) {
					this.geocodeApiCityState(event.currentTarget, '[name=city]', '[name=state]');
				}
				if (!region) {
					if ((value.trim().length === 3 && /^[ABCEGHJKLMNPRSTVXYabceghjklmnprstvxy]{1}\d{1}[A-Za-z]{1}/.test(value.trim())) || (value.trim().length === 7 && COSTCO.util.POSTAL_CODE_REGEX_CA.test(value.trim())))
					this.geocodeApiCityState(event.currentTarget, '[name=city]', '[name=state]');
				}
			}
        }
      }.bind(this));
      // Employee Add On (Acocunt Details)
      form.find('[name=employeeAddon_zip]').on('input', function(event) {
        let value = $(event.currentTarget).val();
        let region = COSTCO.util.isUsOrCaZipCode();
		if($('#isGeocodeService').val() != "true" && value != null && value != "" && value.trim().length > 4){
			this.bingCityState(event.currentTarget, '[name=employeeAddon_city]', '[name=employeeAddon_state]');
		}
		if($('#isGeocodeService').val() === "true" && value != null && value != "" && value.trim().length === value.length){
			if (region && COSTCO.util.POSTAL_CODE_REGEX_US.test(value.trim())) {
				this.geocodeApiCityState(event.currentTarget, '[name=employeeAddon_city]', '[name=employeeAddon_state]');
			}
			if (!region) {
				if ((value.trim().length === 3 && /^[ABCEGHJKLMNPRSTVXYabceghjklmnprstvxy]{1}\d{1}[A-Za-z]{1}/.test(value.trim())) || (value.trim().length === 7 && COSTCO.util.POSTAL_CODE_REGEX_CA.test(value.trim())))
				this.geocodeApiCityState(event.currentTarget, '[name=employeeAddon_city]', '[name=employeeAddon_state]');
			}
		}
      }.bind(this));
      // Business information
      form.find('[name=businessZipCode]').on('input', function(event) {
        let value = $(event.currentTarget).val();
        let region = COSTCO.util.isUsOrCaZipCode();
		if($('#isGeocodeService').val() != "true" && value != null && value != "" && value.trim().length > 4){
			this.bingCityState(event.currentTarget, '[name=businessCity]', '[name=businessState]');
		}
		if($('#isGeocodeService').val() === "true" && value != null && value != "" && value.trim().length === value.length){
			if (region && COSTCO.util.POSTAL_CODE_REGEX_US.test(value.trim())) {
				this.geocodeApiCityState(event.currentTarget, '[name=businessCity]', '[name=businessState]');
			}
			if (!region) {
				if ((value.trim().length === 3 && /^[ABCEGHJKLMNPRSTVXYabceghjklmnprstvxy]{1}\d{1}[A-Za-z]{1}/.test(value.trim())) || (value.trim().length === 7 && COSTCO.util.POSTAL_CODE_REGEX_CA.test(value.trim())))
				this.geocodeApiCityState(event.currentTarget, '[name=businessCity]', '[name=businessState]');
			}
		}
      }.bind(this));
      // Affiliate
      form.find('[name=zip]').on('input', function(event) {
        let value = $(event.currentTarget).val();
        let region = COSTCO.util.isUsOrCaZipCode();
		if($('#isGeocodeService').val() != "true" && value != null && value != "" && value.trim().length > 4){
			this.bingCityState(event.currentTarget, '[name=city]', '[name=state]');
		}
		if($('#isGeocodeService').val() === "true" && value != null && value != "" && value.trim().length === value.length){
			if (region && COSTCO.util.POSTAL_CODE_REGEX_US.test(value.trim())) {
				this.geocodeApiCityState(event.currentTarget, '[name=city]', '[name=state]');
			}
			if (!region) {
				if ((value.trim().length === 3 && /^[ABCEGHJKLMNPRSTVXYabceghjklmnprstvxy]{1}\d{1}[A-Za-z]{1}/.test(value.trim())) || (value.trim().length === 7 && COSTCO.util.POSTAL_CODE_REGEX_CA.test(value.trim())))
				this.geocodeApiCityState(event.currentTarget, '[name=city]', '[name=state]');
			}
		}
      }.bind(this));
      // Account Details - Membership Information
      form.find('[name=MembershipCrmCallerInfo_zipCode]').on('input', function(event) {
        let value = $(event.currentTarget).val();
        let region = COSTCO.util.isUsOrCaZipCode();
		if($('#isGeocodeService').val() != "true" && value != null && value != "" && value.trim().length > 4){
			this.bingCityState(event.currentTarget,
    	            '[name=MembershipCrmCallerInfo_city]',
    	            '[name=MembershipCrmCallerInfo_stateDropDown_state]');
		}
		if($('#isGeocodeService').val() === "true" && value != null && value != "" && value.trim().length === value.length){
			if (region && COSTCO.util.POSTAL_CODE_REGEX_US.test(value.trim())) {
				this.geocodeApiCityState(event.currentTarget,
	    	            '[name=MembershipCrmCallerInfo_city]',
	    	            '[name=MembershipCrmCallerInfo_stateDropDown_state]');
			}
			if (!region) {
				if ((value.trim().length === 3 && /^[ABCEGHJKLMNPRSTVXYabceghjklmnprstvxy]{1}\d{1}[A-Za-z]{1}/.test(value.trim())) || (value.trim().length === 7 && COSTCO.util.POSTAL_CODE_REGEX_CA.test(value.trim())))
				this.geocodeApiCityState(event.currentTarget,
	    	            '[name=MembershipCrmCallerInfo_city]',
	    	            '[name=MembershipCrmCallerInfo_stateDropDown_state]');
			}
		}
      }.bind(this));
      
      //Business Details - Business Information
      form.find('[name=MembershipCrmBusiness_zipCode]').on('input', function(event) {
          let value = $(event.currentTarget).val();
          let region = COSTCO.util.isUsOrCaZipCode();
  		if($('#isGeocodeService').val() != "true" && value != null && value != "" && value.trim().length > 4){
  			this.bingCityState(event.currentTarget,
      	            '[name=MembershipCrmBusiness_city]',
      	            '[name=MembershipCrmBusiness_stateDropDown_state]');
  		}
  		if($('#isGeocodeService').val() === "true" && value != null && value != "" && value.trim().length === value.length){
  			if (region && COSTCO.util.POSTAL_CODE_REGEX_US.test(value.trim())) {
  				this.geocodeApiCityState(event.currentTarget,
  	    	            '[name=MembershipCrmBusiness_city]',
  	    	            '[name=MembershipCrmBusiness_stateDropDown_state]');
  			}
  			if (!region) {
  				if ((value.trim().length === 3 && /^[ABCEGHJKLMNPRSTVXYabceghjklmnprstvxy]{1}\d{1}[A-Za-z]{1}/.test(value.trim())) || (value.trim().length === 7 && COSTCO.util.POSTAL_CODE_REGEX_CA.test(value.trim())))
  				this.geocodeApiCityState(event.currentTarget,
  	    	            '[name=MembershipCrmBusiness_city]',
  	    	            '[name=MembershipCrmBusiness_stateDropDown_state]');
  			}
  		}
        }.bind(this));
      
      // Mask inputs
      this.maskInput(form);
    },
    /**
     * Determine if we're working with a business membership.
     * @return {Boolean} Is business membership?
     */
    isBusinessMembership: function() {
      return this.membershipType === this.membershipTypes.ADDMEMBER_BUSINESS || this.membershipType === this.membershipTypes.ADDMEMBER_BUSINESS_EXECUTIVE;
    },
    /**
     * Sets some static keys representing membership types.
     * @type {Object}
     */
    membershipTypes: {
      ADDMEMBER_BUSINESS: 'ADDMEMBER_BUSINESS',
      ADDMEMBER_BUSINESS_EXECUTIVE: 'ADDMEMBER_BUSINESS_EXECUTIVE',
      ADDMEMBER_GOLDSTAR: 'ADDMEMBER_GOLDSTAR',
      ADDMEMBER_GOLDSTAR_EXECUTIVE: 'ADDMEMBER_GOLDSTAR_EXECUTIVE',
    },
    /**
     * The selectors for address fields in personal information
     * @type {Object}
     */
    personalAddressSelectors: {
      label: '[name=primaryAddress]',
      line1: '[name=address1]',
      line2: '[name=address2]',
      city: '[name=city]',
      state: '[name=state]',
      country: '[name=country]',
      zip: '[name=postalcode]',
    },
    /**
     * The selectors for address fields in business information.
     * @type {Object}
     */
    businessAddressSelectors: {
      label: '[name=businessAddress]',
      line1: '[name=businessAddressLine1]',
      line2: '[name=businessAddressLine2]',
      city: '[name=businessCity]',
      state: '[name=businessState]',
      country: '[name=businessCountry]',
      zip: '[name=businessZipCode]',
    },
    /**
     * The selectors for address fields in the affiliate modal.
     * @type {Object}
     */
    affiliateAddressSelectors: {
      label: '[name=affiliateAddress]',
      line1: '[name=line1]',
      line2: '[name=line2]',
      city: '[name=city]',
      state: '[name=state]',
      country: '[name=country]',
      zip: '[name=zip]',
      fName: '[name=fname]',
      lName: '[name=lname]',
    },
    /**
     * The selectors for address fields in the Account Details
     * Membership Information - Primary Information.
     * @type {Object}
     */
    primaryInformationSelectors: {
      label: '.membership-address-container .title label',
      line1: '[name=MembershipCrmCallerInfo_addressLine1]',
      line2: '[name=MembershipCrmCallerInfo_addressLine2]',
      city: '[name=MembershipCrmCallerInfo_city]',
      state: '[name=MembershipCrmCallerInfo_stateDropDown_state]',
      country: '[name=MembershipCrmCallerInfo_stateDropDown_country]',
      zip: '[name=MembershipCrmCallerInfo_zipCode]',
      month:'[name=MembershipCrmCallerInfo_dobEditMonth]',
      day: '[name=MembershipCrmCallerInfo_dobEditDay]',
      year: '[name=MembershipCrmCallerInfo_dobEditYear]',
    },
    /**
     * The selectors for address fields in the Business Details
     * Membership Information - Primary Information.
     * @type {Object}
     */
    businessInformationSelectors: {
      label: '.business-address-container .title label',
      line1: '[name=MembershipCrmBusiness_addressLine1]',
      line2: '[name=MembershipCrmBusiness_addressLine2]',
      city: '[name=MembershipCrmBusiness_city]',
      state: '[name=MembershipCrmBusiness_stateDropDown_state]',
      country: '[name=MembershipCrmBusiness_stateDropDown_country]',
      zip: '[name=MembershipCrmBusiness_zipCode]',
    },
    /**
     * The selectors for address fields in the employee add on section for when
     * the user is a Employee Primary.
     * @type {Object}
     */
    employeeAddOnSelectors: {
      label: '.employee-addon > .title span',
      line1: '[name=employeeAddon_addressLine1]',
      line2: '[name=employeeAddon_addressLine2]',
      city: '[name=employeeAddon_city]',
      state: '[name=employeeAddon_state]',
      country: '[name=employeeAddon_country]',
      zip: '[name=employeeAddon_zip]',
      fName: '[name=employeeAddon_first_name]',
      lName: '[name=employeeAddon_last_name]',
    },

    /**
     * Business specific rules object. Used for clientside validation
     * @type {Object}
     */
    business: {
      rules: {
        first_name: {required: true, firstNameValidation: true},
        lastName: {required: true, lastNameValidation: true},
        month: {
          required: $('#dobYearMonthMandatoryFlag').val()==='true',
          dob: true,
          isMinor: true,
        },
        day: {
          required: false,
          dob: true,
          isMinor: true,
        },
        year: {
          required: $('#dobYearMonthMandatoryFlag').val()==='true',
          dob: true,
          isMinor: true,
        },
        address1: {
          required: true,
          valid_address: true,
          maxlength: 60,
        },
        address2: {
          valid_address: true,
          maxlength: 40,
        },
        city: {
    	  required: true,
    	  valid_cityState: true,
        },
        state: {
          required: true,
          valid_cityState: true,
          notEqual: 'NO_STATE_TYPE_SELECTED',
          hasvalidationerror: true,
        },
        postalcode: {
          required: true,
          minlength: 5,
        },
        email: {
          required: true,
          singleemail: true,
          email: false,
        },
        emailConfirm: {
          required: true,
          singleemail: true,
          equalTo: '#email',
          email: false,
        },
        // country : 'required',
        contactPhoneNumber: {
          required: true,
          phone: true,
        },
        mobilePhoneNumber: {
          required: false,
          phone: true,
          promo: true,
        },
        // awarenessCode: {required: false, validCode : true},
        shippingNickname: {
          copyAddress: true,
        },
        billingNickname: {
          copyAddress: true,
        },
        businessNameEdit: 'required',
        businessAddressLine1: {
          required: true,
          valid_address: true,
          maxlength: 30,
        },
        businessAddressLine2: {
          valid_address: true,
          maxlength: 30,
        },
        businessCity: {
          required: true,
          valid_cityState: true,
        },
        businessState: {
          required: true,
          valid_cityState: true,
          notEqual: 'NO_STATE_TYPE_SELECTED',
          hasvalidationerror: true,
        },
        // businessCountry : 'required',
        businessZipCode: {
          required: true,
          minlength: 5,
        },
        businessPhone: {
          required: true,
          phone: true,
        },
        businessEmail: {
          required: true,
          singleemail: true,
          email: false,
        },
        businessEmailConfirm: {
          required: true,
          singleemail: true,
          email: false,
          equalTo: '#businessEmail',
        },
      },
      
      messages: function() {
        return {
          month: {required: messages.ERR_INVALID_MONTH_REQUIRED},
          year: {required: messages.ERR_INVALID_YEAR_REQUIRED},
          businessNameEdit: messages.ERR_INVALID_BUSINESS_NAME,
          businessAddressLine1: {
            required: messages.ERR_INVALID_STREET_REQUIRED,
            valid_address: messages.ERR_INVALID_ADDRESS,
            maxlength: messages.ERR_INVALID_STREETADDRESS_LENGTH,
          },
          businessAddressLine2: {
        	valid_address: messages.ERR_INVALID_ADDRESS,
            maxlength: messages.ERR_INVALID_STREETADDRESS_LENGTH,
          },
          businessCity: {required: messages.ERR_INVALID_CITY_REQUIRED, valid_cityState: messages.ERR_INVALID_CITY_NAME},
          businessState: {required: wcs.storeId == '10301' ? messages.ERR_INVALID_STATE_NAME : messages.ERR_INVALID_PROVINCE_REQUIRED, valid_cityState: wcs.storeId == '10301' ? messages.ERR_INVALID_STATE_NAME : messages.ERR_INVALID_PROVINCE_REQUIRED},
          // businessCountry : messages.ERR_INVALID_COUNTRY,
          businessZipCode: {
        	  required: messages.ERR_ENTER_ZIPCODE_NEW,
              minlength: messages.ERR_VALID_ZIPCODE,
          },
          businessPhone: messages.ERR_INVALID_PHONE_10_DIGIT,
          businessEmail: messages.ERR_INVALID_EMAIL_ADDRESS,
          businessEmailConfirm: {
            required: messages.ERR_REQUIRED_CONFIRM_EMAIL,
            equalTo: messages.ERR_CONFIRM_EMAIL_MISMATCH,
          },
          first_name: {required: messages.ERR_INVALID_FNAME_REQUIRED, firstNameValidation: messages.ERR_INVALID_FNAME},
          lastName: {required: messages.ERR_INVALID_LNAME_REQUIRED, lastNameValidation: messages.ERR_INVALID_LNAME},
          address1: {
            required: messages.ERR_INVALID_STREET_REQUIRED,
            valid_address: messages.ERR_INVALID_ADDRESS,
            maxlength: messages.ERR_INVALID_STREETADDRESS_LENGTH_FRIENDLY_MESSAGE,
          },
          address2: {
        	valid_address: messages.ERR_INVALID_ADDRESS,
            maxlength: messages.ERR_INVALID_STREETADDRESS_LENGTH,
          },
          city: {required: messages.ERR_INVALID_CITY_REQUIRED, valid_cityState: messages.ERR_INVALID_CITY_NAME},
          state: {required: wcs.storeId == '10301' ? messages.ERR_INVALID_STATE_NAME : messages.ERR_INVALID_PROVINCE_REQUIRED, valid_cityState: wcs.storeId == '10301' ? messages.ERR_INVALID_STATE_NAME : messages.ERR_INVALID_PROVINCE_REQUIRED},
          postalcode: {
        	  required: messages.ERR_ENTER_ZIPCODE_NEW,
              minlength: messages.ERR_VALID_ZIPCODE,
          },
          email:  messages.ERR_INVALID_EMAIL_ADDRESS,
          emailConfirm: {
            required: messages.ERR_REQUIRED_CONFIRM_EMAIL,
            equalTo: messages.ERR_CONFIRM_EMAIL_MISMATCH,
          },
          // country : messages.ERR_INVALID_COUNTRY,
          contactPhoneNumber: messages.ERR_INVALID_PHONE_10_DIGIT,
          mobilePhoneNumber: messages.ERR_INVALID_PHONE_10_DIGIT,
          // awarenessCode : messages.ERR_AWARENESS_CODE,
          shippingNickname: messages.ERR_ENTER_UNIQUE_NICKNAME,
          billingNickname: messages.ERR_INVALID_SHIPPINGNICKNAME,
        };
      },
    },
    /**
     * Goldstar specific rules object. Used for clientside validation
     * @type {Object}
     */
    goldstar: {
      rules: {
        // primary
        first_name: {required: true, firstNameValidation: true},
        // alternate name for affiliate
        fname: {required: true, firstNameValidation: true},
        // alternate name for employee addon
        employeeAddon_first_name: {required: true, firstNameValidation: true},
        lastName: {required: true, lastNameValidation: true},
        // alternate name for affiliate
        lname: {required: true, lastNameValidation: true},
        // alternamte name for employee addon
        employeeAddon_last_name: {required: true, lastNameValidation: true},
        month: {
          required: $('#dobYearMonthMandatoryFlag').val()==='true',
          dob: true,
          isMinor: true,
        },
    	MembershipCrmCallerInfo_dobEditMonth: {
			required: false,
			dob:true,
		},
		MembershipCrmCallerInfo_dobEditDay: {
			required: false,
			dob:true,
		},
		MembershipCrmCallerInfo_dobEditYear: {
			required: false,
			dob:true,
		},
			
        // alternate name for affiliate
        dobmonth: {
          required: $('#dobYearMonthMandatoryFlag').val()==='true',
          dob: true,
          isMinor: true,
        },
        day: {
          required: false,
          dob: true,
          isMinor: true,
        },
        // alternate name for affiliate
        dobday: {
          required: false,
          dob: true,
          isMinor: true,
        },
        year: {
          required: $('#dobYearMonthMandatoryFlag').val()==='true',
          dob: true,
          isMinor: true,
        },
        // alternate name for affiliate
        dobyear: {
          required: $('#dobYearMonthMandatoryFlag').val()==='true',
          dob: true,
          isMinor: true,
        },
        address1: {
          required: true,
          valid_address: true,
          maxlength: 60,
        },
        address2: {
          maxlength: 40,
          valid_address: true,
        },
        // alternate names for employee addon
        employeeAddon_addressLine1: {
          required: true,
          valid_address: true,
        },
        employeeAddon_addressLine2: {
          valid_address: true,
        },
        employeeAddon_city: {
          required: true,
          valid_cityState: true,
        },
        employeeAddon_state: {
          required: true,
          valid_cityState: true,
          notEqual: 'NO_STATE_TYPE_SELECTED',
          hasvalidationerror: true,
        },
        employeeAddon_zip: {
          required: true,
          minlength: 5,
        },
        // alternate name for affiliate
        line1: {
          required: true,
          valid_address: true,
        },
        line2: {
          valid_address: true,
        },
        city: {
          required: true,
          valid_cityState: true,
        },
        state: {
          required: true,
          valid_cityState: true,
          notEqual: 'NO_STATE_TYPE_SELECTED',
          hasvalidationerror: true,
        },
        postalcode: {
          required: true,
          minlength: 5,
        },
        // alternate name for affiliate
        zip: {
          required: true,
          minlength: 5,
        },
        email: {
          required: true,
          singleemail: true,
          email: false,
          emailEmpty: true,
        },
        emailConfirm: {
          required: true,
          singleemail: true,
          equalTo: '#email',
          email: false,
          emailEmpty: true,
        },
        // alternate name for employee add on
        employeeAddon_email: {
          required: false,
          singleemail: true,
        },
        employeeAddOn_email_confirm: {
          required: false,
          singleemail: true,
          equalTo: '#employeeAddon_email',
        },
        // country : 'required',
        contactPhoneNumber: {
          required: true,
          phone: true,
        },
        // alternate name for affiliate
        cphone: {
          required: false,
          phone: true,
        },
        mobilePhoneNumber: {
          required: false,
          phone: true,
          promo: true,
        },
        // alternate name for affiliate
        mphone: {
          required: false,
          phone: true,
          promo: true,
        },
        // alternate name for employee add on
        employeeAddon_contact_phone: {
          required: true,
          phone: true,
        },
        employeeAddon_mobile: {
          required: false,
          phone: true,
          promo: true,
        },
      },
      messages: function() {
        return {
          first_name: {required: messages.ERR_INVALID_FNAME_REQUIRED, firstNameValidation: messages.ERR_INVALID_FNAME},
          month: {required: messages.ERR_INVALID_MONTH_REQUIRED},
          year: {required: messages.ERR_INVALID_YEAR_REQUIRED},
          dobmonth: {required: messages.ERR_INVALID_MONTH_REQUIRED},
          householdDobYear: {required: messages.ERR_INVALID_YEAR_REQUIRED},
          householdDobMonth: {required: messages.ERR_INVALID_MONTH_REQUIRED},
          dobyear: {required: messages.ERR_INVALID_YEAR_REQUIRED},
          // alternate for affiliate
          fname: {required: messages.ERR_INVALID_FNAME_REQUIRED, firstNameValidation: messages.ERR_INVALID_FNAME},
          // For Account Details
          householdFname: {required: messages.ERR_INVALID_FNAME_REQUIRED, firstNameValidation: messages.ERR_INVALID_FNAME},
          // For Employee Add On
          employeeAddon_first_name: {required: messages.ERR_INVALID_FNAME_REQUIRED, firstNameValidation: messages.ERR_INVALID_FNAME},
          lastName: {required: messages.ERR_INVALID_LNAME_REQUIRED, lastNameValidation: messages.ERR_INVALID_LNAME},
          // alternate for affiliate
          lname: {required: messages.ERR_INVALID_LNAME_REQUIRED, lastNameValidation: messages.ERR_INVALID_LNAME},
          // For Account Details
          householdLname: {required: messages.ERR_INVALID_LNAME_REQUIRED, lastNameValidation: messages.ERR_INVALID_LNAME},
          // For Employee Add On
          employeeAddon_last_name: {required: messages.ERR_INVALID_LNAME_REQUIRED, lastNameValidation: messages.ERR_INVALID_LNAME},
          address1: {
            required: messages.ERR_INVALID_STREET_REQUIRED,
            valid_address: messages.ERR_INVALID_ADDRESS,
            maxlength: messages.ERR_INVALID_STREETADDRESS_LENGTH_FRIENDLY_MESSAGE,
          },
          address2: {
        	valid_address: messages.ERR_INVALID_ADDRESS,
            maxlength: messages.ERR_INVALID_STREETADDRESS_LENGTH,
          },
          // alternate for employee add on
          employeeAddon_addressLine1: {
            required: messages.ERR_INVALID_STREET_REQUIRED,
            valid_address: messages.ERR_INVALID_ADDRESS,
          },
          employeeAddon_addressLine2: {
            valid_address: messages.ERR_INVALID_ADDRESS,
          },
          employeeAddon_city: {
        	required: messages.ERR_INVALID_CITY_REQUIRED,
        	valid_cityState: messages.ERR_INVALID_CITY_NAME,
          },
          employeeAddon_state: {
        	required: messages.ERR_INVALID_STATE_NAME,
        	valid_cityState: messages.ERR_INVALID_STATE_NAME,
          },
          employeeAddon_zip: {
        	  required: messages.ERR_ENTER_ZIPCODE_NEW,
              minlength: messages.ERR_VALID_ZIPCODE,
          },
          // alternate for affiliate
          line1: {
        	required: messages.ERR_INVALID_STREET_REQUIRED,
        	valid_address: messages.ERR_INVALID_ADDRESS,  
          },
          line2: {
        	valid_address: messages.ERR_INVALID_ADDRESS,
          },
          city: {
        	required: messages.ERR_INVALID_CITY_REQUIRED,
        	valid_cityState: messages.ERR_INVALID_CITY_NAME,
          },
          state: {
          	required: wcs.storeId == '10301' ? messages.ERR_INVALID_STATE_NAME : messages.ERR_INVALID_PROVINCE_REQUIRED,
          	valid_cityState: wcs.storeId == '10301' ? messages.ERR_INVALID_STATE_NAME : messages.ERR_INVALID_PROVINCE_REQUIRED,
          },
          postalcode: {
        	  required: messages.ERR_ENTER_ZIPCODE_NEW,
              minlength: messages.ERR_VALID_ZIPCODE,
          },
          // alternate for affiliate
          zip: {
        	  required: messages.ERR_ENTER_ZIPCODE_NEW,
              minlength: messages.ERR_VALID_ZIPCODE,
          },
          email: messages.ERR_INVALID_EMAIL,
          emailConfirm: {
              required: messages.ERR_REQUIRED_CONFIRM_EMAIL,
              equalTo: messages.ERR_CONFIRM_EMAIL_MISMATCH,
            },
          equalTo: messages.ERR_CONFIRM_EMAIL_MISMATCH,
          // alternate for employee add on
          employeeAddon_email: messages.ERR_INVALID_EMAIL,
          // country : messages.ERR_INVALID_COUNTRY,
          contactPhoneNumber: messages.ERR_INVALID_PHONE_10_DIGIT,
          // alternate for affiliate
          cphone: messages.ERR_INVALID_PHONE_10_DIGIT,
          mobilePhoneNumber: messages.ERR_INVALID_PHONE_10_DIGIT,
          // alternate for affiliate
          mphone: messages.ERR_INVALID_PHONE_10_DIGIT,
          // alternate for employee add on
          employeeAddon_contact_phone: messages.ERR_INVALID_PHONE_10_DIGIT,
          employeeAddon_mobile: messages.ERR_INVALID_PHONE_10_DIGIT,
        };
      },
    },
    /**
     * Extend a 'business' or 'goldstar' rules object with household
     * rules.
     * @param  {Object} rules The rules object to extend
     * @param  {boolean} required OPTIONAL make something required
     * @return {void}
     */
    addHouseholdRules: function(rules, required, validator_messages) {
    	required = required || false
      $.extend(rules, {
        household_first_name: {
          required: false,
          firstNameValidation: true,
          household_gold: true,
        },
        // Affiliate alternate
        householdFname: {
          required: required || false,
          firstNameValidation: true,
          household_gold: required === true ? false : true,
        },
        household_lastName: {
          required: false,
          lastNameValidation: true,
          household_gold: true,
        },
        // Affiliate alternate
        householdLname: {
          required: required || false,
          lastNameValidation: true,
          household_gold: required === true ? false : true,
        },
        household_month: {
          required: $('#dobYearMonthMandatoryFlag').val()==='true',
          dob: true,
          isMinor: true,
        },
        // Affiliate alternate
        householdDobMonth: {
          required: $('#dobYearMonthMandatoryFlag').val()==='true',
          dob: true,
          isMinor: true,
        },
        household_day: {
          required: false,
          dob: true,
          isMinor: true,
        },
        // Affiliate alternate
        householdDobDay: {
          required: false,
          dob: true,
          isMinor: true,
        },
        household_year: {
          required: $('#dobYearMonthMandatoryFlag').val()==='true',
          dob: true,
          isMinor: true,
        },
        // Affiliate alternate
        householdDobYear: {
          required: $('#dobYearMonthMandatoryFlag').val()==='true',
          dob: true,
          isMinor: true,
        },
        household_email: {
          required: false,
          singleemail: true,
          household_gold: false,
          email: false,
          emailEmpty: true,
        },
        household_emailConfirm: {
          required: false,
          singleemail: true,
          equalTo: '#household_email',
          email: false,
          emailEmpty: true,
        },
        // Affiliate alternate
        householdEmail: {
          required: false,
          singleemail: true,
          household_gold: false,
          email: false,
          emailEmpty: true,
        },
        // Affiliate alternate
        householdEmailConfirm: {
          required: false,
          singleemail: true,
          equalTo: '#household_email_affiliate',
          email: false,
          emailEmpty: true,
        },
        // Alternate for Account Details
        householdEmailConfirmdetails: {
          required: false,
          singleemail: true,
          equalTo: '#email-details',
          email: false,
          emailEmpty: true,
        },
        household_primaryPhoneNumber: {
          required: false,
          phone: true,
          household_gold: false,
        },
        // Affiliate alternate
        householdPrimaryPhoneNumber: {
          required: false,
          phone: true,
          household_gold: false,
        },
      });
      $.extend(validator_messages, {
    	  household_month: {required: messages.ERR_INVALID_MONTH_REQUIRED},
    	  household_year: {required: messages.ERR_INVALID_YEAR_REQUIRED},
      });
    },
    /**
     * Validation methods for membership specific forms.
     * @param  {jQuery} form The form we're validating
     * @return {void}
     */
    addValidationMethods: function(form) {
      let memberValidationRegex = new RegExp($('#memberValidationRegex').val());
      let addressValidationRegex = new RegExp($('#addressValidationRegex').val());
      let cityStateValidationRegex = new RegExp($('#cityStateValidationRegex').val());
      $.validator.addMethod('notEqual', function(value, element, param) {
        return this.optional(element) || value != param;
      }, messages.ERR_INVALID_STATE_NAME);
      $.validator.addMethod("hasvalidationerror", function(value, element) {
			return element.getAttribute('hasvalidationerror') == undefined || element.getAttribute('hasvalidationerror') == null || element.getAttribute('hasvalidationerror') == "false"
	  }, messages.ERR_INVALID_STATE);
      // custom validate mobile phone number when promo notification via text message is selected.
      $.validator.addMethod('promo', function(value, element, param) {
        let valid = true;
        let phone = $.trim(form.find('input[name=mobilePhoneNumber]').val());
        let promo = $('input[name=receivePromosAndMarketingTxtMsg]').val();
        if (promo == 'on' && phone.length == 0) {
          valid = false;
        }
        return valid;
      }, '');
      // custom validation for date of birth
      $.validator.addMethod('dob', function(value, element, param) {
        let valid = true;
        let month;
        let day;
        let year;
        let monthVal;
        let dayVal;
        let yearVal;
        let errField;
        let message;
        let dateCondition = false;
        let idate;
        let isFuture = false;
        let isFutureDate = function(idate) {
          let today = new Date().getTime();
          idate = idate.split('/');
          idate = new Date(idate[2], idate[0] - 1, idate[1]).getTime();
          return (today - idate) < 0 ? true : false;
        };
        if (element.name == 'month' || element.name == 'day' || element.name == 'year') {
  		  month = form.find('[name=month]');
		  day = form.find('[name=day]');
		  year = form.find('[name=year]');
          errField = '#dob_error';
        } else if (element.name == 'MembershipCrmCallerInfo_dobEditMonth' || element.name == 'MembershipCrmCallerInfo_dobEditDay' ||
          element.name == 'MembershipCrmCallerInfo_dobEditYear') {
  		  month = form.find('[name=MembershipCrmCallerInfo_dobEditMonth]');
		  day = form.find('[name=MembershipCrmCallerInfo_dobEditDay]');
		  year = form.find('[name=MembershipCrmCallerInfo_dobEditYear]');
          errField = '#MembershipCrmCallerInfo-dob-error';
        } else if (element.name == 'household_month' || element.name == 'household_day' || element.name == 'household_year') {
  		  month = form.find('[name=household_month]');
		  day = form.find('[name=household_day]');
		  year = form.find('[name=household_year]');
          errField = '#household_dob_error';
        } else if (element.name == 'dobmonth' || element.name == 'dobday' || element.name == 'dobyear') {
          month = form.find('[name=dobmonth]');
          day = form.find('[name=dobday]');
          year = form.find('[name=dobyear]');
          errField = '#dob_error_affiliate';
        } else if (element.name == 'householdDobMonth' || element.name == 'householdDobDay' || element.name == 'householdDobYear') {
  		  month = form.find('[name=householdDobMonth]');
		  day = form.find('[name=householdDobDay]');
		  year = form.find('[name=householdDobYear]');
          errField = element.form.id == 'household-form-details' ? '#household_dob_error_details' : '#household_dob_error_affiliate';
        }
        
        const dayIsOptional = $('#dobYearMonthMandatoryFlag').val()==='true'
        const isDayElement = element.name === 'day' || element.name == 'household_day' || element.name == 'dobday' || element.name == 'householdDobDay';
        	
        monthVal = month.val();
        dayVal = day.val();
        if(dayIsOptional && dayVal == "") {
          dayVal = "1";
        }
        yearVal = year.val();
        
        if(!dayIsOptional) {
            if (wcs.storeId == '10301') {
                dateCondition = ((monthVal == 'Month' && dayVal == 'Day' && yearVal == 'Year') || (monthVal != 'Month' && dayVal != 'Day' && yearVal != 'Year'));
                if (monthVal.length > 0 || dayVal.length > 0 || yearVal.length > 0) {
              	  if (monthVal.length == 0 || dayVal.length == 0 || yearVal.length == 0) {
              		  dateCondition = false;
              	  }
                }
            } else if ((wcs.storeId == '10302')) {
                dayVal = 1;
                dateCondition = ((monthVal == 'Month' && yearVal == 'Year') || (monthVal != 'Month' && yearVal != 'Year'));
                if (monthVal.length > 0 || yearVal.length > 0) {
              	  if (monthVal.length == 0 || yearVal.length == 0) {
              		  dateCondition = false;
              	  }
                }
            }
        } else {
        	dateCondition = true;
        }
        if (monthVal != 'Month' && dayVal != 'Day' && yearVal != 'Year') {
          idate = monthVal + '/' + dayVal + '/' + yearVal;
          if (isFutureDate(idate)) isFuture = true;
        }
        if (dateCondition && !isFuture && COSTCO.util.dateValidation(monthVal, dayVal, yearVal)) {
          $(errField).hide();
          month.removeClass('error');
    	  day.removeClass('error');
    	  year.removeClass('error');
          valid = true;
        } else {
        	if(dayIsOptional && day.val() === "" && month.val() === "" && year.val() === "" && isDayElement){
  	          valid = true;
        	} else {
	          month.addClass('error');
	          if (!dayIsOptional) {
        		  day.addClass('error');
	          } else {
	        	  if(day.val() !== ""){
	        		  day.addClass('error');
	        	  }
	          }
	      	  year.addClass('error');
	          $(errField).show();
	          $(errField)[0].innerHTML = messages.ERR_ENTER_DOB;
	          valid = false;
        	}
        }
        return valid;
      }, '');
      // custom validation for checking if the member is over 18
      $.validator.addMethod('isMinor', function(value, element, param) {
      let errorField;
    	let year;
    	let month;
    	let day;
      let now = new Date();
      let graymsg = false;
      let houseHoldForm = false;
      let employeeAddOn = false;
      	
      	if (element.name == 'month' || element.name == 'day' || element.name == 'year') {
    	  month = form.find('[name=month]');
  		  day = form.find('[name=day]');
  		  year = form.find('[name=year]');
  		  errorField = '.member-dob-disclaimer';
  		  graymsg = true;
        } else if (element.name == 'household_month' || element.name == 'household_day' || element.name == 'household_year') {
    	  month = form.find('[name=household_month]');
  		  day = form.find('[name=household_day]');
  		  year = form.find('[name=household_year]');
  		  errorField = '#is_minor_household';
        houseHoldForm = true;
  		} else if (element.name == 'householdDobMonth' || element.name == 'householdDobDay' || element.name == 'householdDobYear') {
    	  month = form.find('[name=householdDobMonth]');
  		  day = form.find('[name=householdDobDay]');
  		  year = form.find('[name=householdDobYear]');
  		  errorField = element.form.id == 'household-form-details' ? '#is_minor_household' : '.household-dob-disclaimer';
  		  graymsg = element.form.id == 'household-form-details' ? false : true;
        houseHoldForm = true;
  		} else if (element.name == 'dobmonth' || element.name == 'dobday' || element.name == 'dobyear') {
        month = form.find('[name=dobmonth]');
        day = form.find('[name=dobday]');
        year = form.find('[name=dobyear]');
        errorField = '.member-dob-disclaimer';
        graymsg = true;
      }
      	
      	let ageYears = now.getFullYear() - year.val();
      	let ageMonths = now.getMonth() - month.val();
      	let ageDays = now.getDate() - day.val();
        let isValidAge = true;
        let primaryMinAge = $('#membership_primary_min_age').val();
        let addOnMinAge = $('#employee-addOn').val();

        let isAgeAllowed = function(minAge) {
          const dayIsOptional = $('#dobYearMonthMandatoryFlag').val()==='true'
          let d = day.val();
          if(dayIsOptional && d == "") {
        	 d = "1";
          }
          let idate = new Date(year.val(), month.val()-1, d);			  
          let today = new Date();
          let birthDate = new Date(idate);
          let age = today.getFullYear() - birthDate.getFullYear();
          let m = today.getMonth() - birthDate.getMonth();
          if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
              age--;
          }
          return age >= minAge ? true : false;
       };
  
        //household member age dropped from 18 to 16
       if (!month.val() == "" && !year.val() == ""){
        if (houseHoldForm) {
          if (!isAgeAllowed(16)) {
            isValidAge = false;
          }
        } else if(addOnMinAge) {
            if (!isAgeAllowed(addOnMinAge)) {
              isValidAge = false;
            }
        } else {
          if (!isAgeAllowed(primaryMinAge)) {
            isValidAge = false;
          }
        }
       }

        if(!isValidAge) {
          month.addClass('error');
          day.addClass('error');
          year.addClass('error');
          if (graymsg) {
            $(errorField).css('color', '#d32029');
          } else {
            $(errorField).show();
            if(houseHoldForm) {
              $(errorField).innerHTML = messages.ERR_HOUSE_DOB_MINOR;
            } else {
              $(errorField).innerHTML = messages.ERR_DOB_MINOR.replace('{0}', primaryMinAge);
            }
          } 
          return false;
        } else {
          if (graymsg) {
            $(errorField).css('color', '#707070');
          } else {
            month.removeClass('error');
            day.removeClass('error');
            year.removeClass('error');
            $(errorField).hide();
          }
          return true;
        }   	
      }, '');
      $.validator.addMethod('valid_address', function(value, element) {
        return (value !== null && value !== '') ?  addressValidationRegex.test(value.trim()) : true;  
      }, '');
      $.validator.addMethod('valid_cityState', function(value, element) {
    	return (value !== null && value !== '') ? cityStateValidationRegex.test(value.trim()) : true;  
      }, '');
      // custom validation for household_goldstar
      $.validator.addMethod('household_gold', function(value, element, param) {
    	  let fName;
    	  let lName;
    	  let email;
    	  let emailConf;
    	  let phone;
    	  let errorFirst;
    	  let errorLast;
    	  let valid = true;
    	  if (element.name == 'household_first_name' || element.name == 'household_lastName' 
    		  || element.name == 'household_email' || element.name == 'household_primaryPhoneNumber'
    		  || element.name == 'household_emailConfirm') {
    		 fName = form.find('input[name=household_first_name]').val();
    		 lName = form.find('input[name=household_lastName]').val();
    		 email = form.find('input[name=household_email]').val();
    		 emailConf = form.find('input[name=household_emailConfirm]').val();
    		 phone = form.find('input[name=household_primaryPhoneNumber]').val();
    		 errorFirst = '#household_first_name_error';
    		 errorLast = '#household_last_name_error';
    	  }
    	  else if (element.name == 'householdFname' || element.name == 'householdLname' 
    		  || element.name == 'householdEmail' || element.name == 'householdPrimaryPhoneNumber'
    		  || element.name == 'householdEmailConfirm') {
    		 fName = form.find('input[name=householdFname]').val();
     		 lName = form.find('input[name=householdLname]').val();
     		 email = form.find('input[name=householdEmail]').val();
     		 emailConf = form.find('input[name=householdEmailConfirm]').val();
     		 phone = form.find('input[name=householdPrimaryPhoneNumber]').val();
     		 errorFirst = '#household_first_name_error_affiliate';
     		 errorLast = '#household_last_name_error_affiliate';
    	  }
    	  $(errorFirst).hide();
    	  $(errorLast).hide();
    	  if (fName.length == 0 && lName.length == 0 && email.length == 0 && emailConf.length == 0 && phone.length == 0) {
    		  $(errorFirst).hide();
    		  $(errorLast).hide();
    		  valid = true;
    	  }
    	  else if ((fName.length == 0 && lName.length == 0) && (email.length > 0 || phone.length > 0 || emailConf.length > 0)) {
    		  $(errorFirst).innerHTML = messages.ERR_INVALID_FNAME_REQUIRED;
    		  $(errorLast).innerHTML = messages.ERR_INVALID_LNAME_REQUIRED;
    		  $(errorFirst).show();
    		  $(errorLast).show();
    		  valid = false;
    	  }
    	  else if (!(fName.length > 0 && lName.length > 0)) {
    	     if (fName.length > 0 && lName.length == 0) {
    	       $(errorFirst).hide(); 
      	       $(errorLast).innerHTML = messages.ERR_INVALID_LNAME_REQUIRED;	
	           $(errorLast).show();
	           if (element.name == 'household_first_name' || element.name == 'householdFname') {
	        	   valid = true;
	           }
	           else if (element.name == 'household_lastName' || element.name == 'householdLname') {
	        	   valid = false;
	           }
    	     }
    	     else if (fName.length == 0 && lName.length > 0) {
    	       $(errorLast).hide();
    	       $(errorFirst).innerHTML = messages.ERR_INVALID_FNAME_REQUIRED;	
      	       $(errorFirst).show();
      	       if (element.name == 'household_first_name' || element.name == 'householdFname') {
	        	   valid = false;
	           }
	           else if (element.name == 'household_lastName' || element.name == 'householdLname') {
	        	   valid = true;
	           }
    	     }
    	  }
    	  return valid;
      }, '');
      $.validator.addMethod('copyAddress', function(value, element, param) {
        let valid = true;
        let checked = $('input[name=copyMembershipAddressToShippingBilling]').attr('checked');
        if (checked == 'checked' && ($(element).val() == '' || ($('input[name=shippingNickname]').val() == $('input[name=billingNickname]').val()))) {
          valid = false;
        }
        return valid;
      }, '');
      $.validator.addMethod('phone', function(value, element) {
    	if (value.startsWith("0") || value.startsWith("1")) {
    		return false;
    	}
        // costco phone numbers are 10 digits with optional .-() and space
    	else return this.optional(element) || /^\(?\d{3}\)?[ -.]?\d{3}[ -.]?\d{4}$/.test(value);
      }, messages.ERR_INVALID_PHONE_10_DIGIT);
      // custom validation rule for single email
      $.validator.addMethod('singleemail', function(value, element) {
        let flag = true;
        flag = flag && /^\s*((([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+(\.([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+)*)|((\x22)((((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(([\x01-\x08\x0b\x0c\x0e-\x1f\x7f]|\x21|[\x23-\x5b]|[\x5d-\x7e]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(\\([\x01-\x09\x0b\x0c\x0d-\x7f]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))))*(((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(\x22)))@((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.?\s*$/.test(value.toLowerCase());
        return this.optional(element) || flag;
      }, messages.ERR_INVALID_EMAIL_ADDRESS);
      $.validator.addMethod('equalTo', function(value, element, param) {
        let flag = true;
        flag = flag && (value === $(param).val());
        return this.optional(element) || flag;
      }, messages.ERR_CONFIRM_EMAIL_MISMATCH);
      $.validator.addMethod('emailEmpty', function(value, element) {
    	let email;
    	if (element.name == 'household_emailConfirm') {
    	  email = form.find('input[name=household_email]').val();
    	}
    	else if (element.name == 'householdEmailConfirm' || element.name == 'householdEmailConfirmdetails') {
    	  email = form.find('input[name=householdEmail]').val();
    	}
    	else if (element.name == 'household_email') {
      	  email = form.find('input[name=household_emailConfirm]').val();
      	}
    	else if (element.name == 'householdEmail') {
    	  if (form.find('input[name=householdEmailConfirm]').length) {
    	    email = form.find('input[name=householdEmailConfirm]').val();  
    	  }
    	  else {
    		email = form.find('input[name=householdEmailConfirmdetails]').val();  
    	  }
      	}
    	else if (element.name == 'emailConfirm') {
      	  if ($(element).attr('id') == 'affiliate-emailConfirm') {
      	    email = form.find('input[name=email]').val();  
      	  }
      	  else {
      		return true;  
      	  }
        }
    	else if (element.name == 'email') {
    	  if ($(element).attr('id') == 'affiliate-email') {
    	    email = form.find('input[name=emailConfirm]').val();  
    	  }
    	  else {
    		return true;  
    	  }
        }
        let isOtherFieldEmpty = email == null || email == '';
        if (!isOtherFieldEmpty && (value == null || value == '')) {
        	return false;
        }
        else return true;
      }, messages.ERR_INVALID_EMAIL_ADDRESS);
      /** STRY0157080 Require at least ONE alphabet in each of the name fields */
      $.validator.addMethod("firstNameValidation", function( value, element ) {
    	  return (value !== null && value !== '') ? (COSTCO.util.ATLEAST_ONE_ALPHABET.test(value) && memberValidationRegex.test(value.trim())) : true;
      }, messages.ERR_INVALID_FNAME);
      $.validator.addMethod("lastNameValidation", function( value, element ) {
    	  return (value !== null && value !== '') ? (COSTCO.util.ATLEAST_ONE_ALPHABET.test(value) && memberValidationRegex.test(value.trim())) : true;
      }, messages.ERR_INVALID_LNAME);
    },
    /**
     * If 'configProduct' exists with the appropriate properties,
     * prepopulate the inputs. This function uses the data-configproduct
     * attribute on inputs in the MembershipApplicationTemplates.jsp.
     * @param {Object} data The data returned from a call to the server
     *                      for application meta data.
     * @return {Object} The data passed to the function
     */
    prepopulateForm: function(data) {
      let configProduct = data.configProduct || this.getConfigProduct();
      if (configProduct) {
        let locale = COSTCO.util.getLocale();
        // Do the populating
        Object.keys(configProduct).forEach((key) => {
          // These keys have to handled specialy because of our Canadian friends.
          if (key == 'thirdPartyInformationSharing' || key == 'costcoMail' ||
            key == 'costcoEmail') {
            if (locale == 'en-US' ||
              (locale != 'en-US' && key == 'costcoMail')) {
              // The old logic in NewMembershipApplicationHelper.js says
              // only prepopulate the costcoMail preference if we're in Canada
              configProduct[key].toLowerCase() == 'yes' ?
                $(`[data-configproduct=${key}]`).prop('checked', true) :
                $(`[data-configproduct=${key}]`).prop('checked', false);
            }
          } else {
            $(`[data-configproduct=${key}]`).val(configProduct[key]);
          }
        });
        if(costcoStoreFeatures.DERIVE_CITY_STATE_FROM_ZIP_POSTAL_CODE_ENABLED 
			&& $('input[name=deriveCityStateEnabled]') && $('input[name=deriveCityStateEnabled]').val() === "true"){
            COSTCO.MembershipHelper.populateCityStateForDefaultZip(configProduct);
        }
      }
      return data;
    },
    /**
     * Uses the default address zip code obtained from the 'configProduct' (from
     * the data returned from a call to the server), in order to make a geocodeAPI 
     * call and populate the city and state fields with the values from the service 
     * response for the user to choose from (if editing the address)
     */
    populateCityStateForDefaultZip(configProduct) {
    	
    	if($('#postalcode')){
        	var defaultAddrCity = configProduct.city;
        	var defaultAddrState = configProduct.state;
        	var defaultAddrZip = configProduct.zip || configProduct.zipCode;
        	if(defaultAddrZip && defaultAddrCity && defaultAddrState && $('#postalcode').val()){
        		COSTCO.CAddress.geocodeApiCityState($('#postalcode'),'[name=city]','[name=state]', defaultAddrCity, defaultAddrState);
        	}
    	}
    	
    	if($('#businessZipCode')){
        	var defaultCompAddrCity = configProduct.companyCity;
        	var defaultCompAddrState = configProduct.companyState;
        	var defaultCompAddrZip = configProduct.companyZip || configProduct.companyZipCode;
        	if(defaultCompAddrZip && defaultCompAddrCity && defaultCompAddrState && $('#businessZipCode').val()){
        		COSTCO.CAddress.geocodeApiCityState($('#businessZipCode'),'[name=businessCity]','[name=businessState]', defaultCompAddrCity, defaultCompAddrState);
        	}
    	}

    },
    /**
     * Populates a given element with keys from the obj who's property
     * names match data-configProduct assigned on inputs of the element.
     * @param  {jQuery} element The element we want to populate.
     * @param  {Object} obj  The object who's keys want want to iterate
     *                       through
     * @return {jQuery}      Returns the processed element to manipulate further.
     */
    populateElement(element, obj) {
      Object.keys(obj).forEach((key) => {
        $(element).find(`[data-configproduct=${key}]`).val(obj[key]);
      });
      if(costcoStoreFeatures.DERIVE_CITY_STATE_FROM_ZIP_POSTAL_CODE_ENABLED 
    		  && $('input[name=deriveCityStateEnabled]') && $('input[name=deriveCityStateEnabled]').val() === "true"){
          COSTCO.MembershipHelper.populateCityStateForDefaultZip(obj);
      }
      
      return element;
    },
    /**
     * Populate a form using a serilized array ($.fn.serializeArray).
     * serilizeArray returns an array of objects where each object represents
     * an input/select/... element who's "name" attribute matches the "name"
     * property
     * @param  {jQuery.Object}  form  The form to populate
     * @param  {Array}          arr   The array of objects to use to populate
     * @return {void}
     */
    populateByName(form, arr) {
      arr.forEach((obj) => {
        $(form).find(`[name=${obj.name}]`).val(obj.value);
      });
    },
    /**
     * Uses the provided affiliate object to build a serialized array of
     * objects using the form fields from the affiliate template.
     * @param  {Object} affiliate The object which is the source
     * @return {Array}            The array of objects
     */
    getSerializedAffiliateData(affiliate) {
      let $form = $(COSTCO.util.tmpl('tmpl_affiliate', {
        affiliateHousehold: COSTCO.util.tmpl('tmpl_household_info_affiliate', {}),
      }));
      // We need to populate the options for dob
      this.dobPopulate($form, 100);
      if(costcoStoreFeatures.DERIVE_CITY_STATE_FROM_ZIP_POSTAL_CODE_ENABLED 
  			&& $('input[name=deriveCityStateEnabled]') && $('input[name=deriveCityStateEnabled]').val() === "true"){
    	// We need to populate the form's state drop down
          if ($form.find('.state-select').length) {
            let stateProvList = this.getStateProvJson();
            let stateOptions = this.getStateOptions(stateProvList);
            $form.find('.state-select').append(stateOptions);
          }
      }
      // Prepopulate the form with existing affiliate data
      $form = this.populateElement($form, affiliate);
      // If theres a household attached to affiliate, populate it
      if (affiliate.houseHold) {
        $form.find('#affiliate-household').prop('checked', true);
        $form.find('#affiliate-household').val(true);
        this.populateElement($form.find('#affiliate-household-container'),
          affiliate.houseHold);
      } else {
        $form.find('#affiliate-household').prop('checked', false);
        $form.find('#affiliate-household').val(false);
      }
      return $form.serializeArray();
    },
    /**
     * TRAIL: Refactor - this is not the best way how this function should be
     * implemented
     * Populate date of birth selects: month, day, year
     * Structure of html
     * <div class="dobPopulate">
     * <select class="month"/>
     * <select class="day"/>
     * <select class="year"/>
     * </div>
     * Using this JS - dobPopulate("100") Populates the difference of 100 from
     * the current year (20XX - 100)
     * @param  {[type]} template      [description]
     * @param  {[type]} appConfigYear [description]
     * @return {void}               [description]
     */
    dobPopulate: function(template, appConfigYear) {
      let elements = $(template).find('.dobPopulate');
      elements.each(function(index, el) {
        let currentYear = new Date().getFullYear();
        let beginningYear = currentYear - parseInt(appConfigYear);
        let $monthSelect = $(el).find('.month');
        let $daySelect = $(el).find('.day');
        let $yearSelect = $(el).find('.year');
        // Populate year select
        let _yearSelect = $('<select>');
        for (let i = currentYear; i >= beginningYear; i--) {
          _yearSelect.append($('<option></option>').val(i).html(i));
        }
        if ($yearSelect.find('option').length <= 1) {
          $yearSelect.append(_yearSelect.html());
        }
        // Populate month select
        let _monthSelect = $('<select>');
        for (let i = 1; i <= 12; i++) {
          _monthSelect.append($('<option></option>').val(i).html(i));
        }
        if ($monthSelect.find('option').length <= 1) {
          $monthSelect.append(_monthSelect.html());
        }
        // Initialize day select options
        let _daySelect = $('<select>');
        for (let i = 1; i <= 31; i++) {
          _daySelect.append($('<option></option>').val(i).html(i));
        }
        if ($daySelect.find('option').length <= 1) {
          $daySelect.append(_daySelect.html());
        }
        // Event handler for changing year and month
        $yearSelect.change(function() {
          MembershipHelper.getDaysOfMonth({
            year: $yearSelect.find('option:selected').val(),
            month: $monthSelect.find('option:selected').val(),
            daySelect: $daySelect,
          });
        });
        $monthSelect.change(function() {
          MembershipHelper.getDaysOfMonth({
            year: $yearSelect.find('option:selected').val(),
            month: $monthSelect.find('option:selected').val(),
            daySelect: $daySelect,
          });
        });
        $monthSelect.add($daySelect).add($yearSelect).each(function(i, select) {
          // If the select has a readonly attribute, disable all options
          // except the currently selected option.
          if ($(select).attr('readonly')) { // will return "readonly"
            $(select).find('option').attr('disabled', 'disabled');
          }
        });
      });
    },
    /**
     * Get the days of the month specific to the context year/month
     * @param  {Object} options The object with year, month and the day <select>
     * @return {void}
     */
    getDaysOfMonth: function(options) {
      let selected;
      let $daySelect = options.daySelect;
      if (!isNaN(parseInt($daySelect.find('option:selected').val()))) {
        selected = $daySelect.find('option:selected').val();
      }
      if (!isNaN(parseInt(options.year)) && !isNaN(parseInt(options.month))) {
        // Remove numbered options from day select
        $daySelect.find('option').each(function(index, element) {
          if (!isNaN(element.value)) {
            try {
              element.remove(); // ie fail
            } catch (err) {}
          }
        });
        let daysInMonth = new Date(options.year, options.month, 0).getDate();
        let _daySelect = $('<select>');
        for (let i = 1; i <= daysInMonth; i++) {
          _daySelect.append($('<option></option>').val(i).html(i));
        }
        $daySelect.append(_daySelect.html());
        if (typeof selected != 'undefined') {
          $daySelect.find('option[value="' + selected + '"]').prop('selected', true);
        }
      }
    },
    /**
     * Uses Jquery Mask plugin to format input. Use cleanVal() instead of val()
     * to get unformatted value
     * @param  {[type]} template [description]
     * @return {void}          [description]
     */
    maskInput: function(template) {
      $(template).find('[name=contactPhoneNumber],[name=cphone],[name=MembershipCrmCallerInfo_phone]').unmask().mask('000-000-0000');
      $(template).find('[name=mobilePhoneNumber],[name=mphone],[name=MembershipCrmCallerInfo_mobile]').unmask().mask('000-000-0000');
      $(template).find('[name=businessPhone]').unmask().mask('000-000-0000');
      $(template).find('[name=household_primaryPhoneNumber],[name=householdPrimaryPhoneNumber]').unmask().mask('000-000-0000');
      $(template).find('[name=month],[name=household_month],[name=householdDobMonth],[name=dobmonth],[name=MembershipCrmCallerInfo_dobEditMonth],[name=day],[name=household_day],[name=householdDobDay],[name=dobday],[name=MembershipCrmCallerInfo_dobEditDay]').unmask().mask('00');
      
      $(template).find('[name=year],[name=household_year],[name=householdDobYear],[name=dobyear],[name=MembershipCrmCallerInfo_dobEditYear]').unmask().mask('0000');
      if (addressForm.isUS()) {
        $(template).find('[name=postalcode],[name=zip],[name=MembershipCrmCallerInfo_zipCode]').unmask().mask('00000-0000');
        $(template).find('[name=businessZipCode]').unmask().mask('00000-0000');
        $(template).find('[name=employeeAddon_zip]').unmask().mask('00000-0000');
      } else {
        $(template).find('[name=postalcode],[name=zip],[name=MembershipCrmCallerInfo_zipCode]').unmask().mask('S0S 0S0');
        $(template).find('[name=businessZipCode]').unmask().mask('S0S 0S0');
        $(template).find('[name=employeeAddon_zip]').unmask().mask('S0S 0S0');
      }
    },
    /**
     * This function is used showing server side errors returned from
     * calling various membership related ajax services. If we have an
     * error, we show it at the top and scroll to it.
     * @param  {Object} data The membership application meta data
     * @return {Object}      The membership application meta data
     */
    handleErrors: function(data) {
      let hasErrors = data && data.error && data.errorMessages && data.errorMessages.length > 0;
      let errorHtml = '';
      let $selectors = $('#server-error, #notification-message');
      if (data && !data.retainNotification || hasErrors) {
        $selectors.addClass('hide').children().remove();
      }
      if (data && data.status && data.status === 500) {
        data = {
          error: true,
          errorMessages: ['Unexpected Error'],
        };
      }
      if (data && data.error && data.errorMessages) {
        // First clear div#notification-message (needed on Add People Outside Renewal page)
        COSTCO.util.notification.clearNotification();
        $selectors.addClass('critical-notification');
        for (let i = 0, len = data.errorMessages.length; i < len; i++) {
        	if (data.errorMessages[i] === '_ERR_INVALID_SHIP_ADDR') {
        	  data.errorMessages[i] = messages.ERR_SHIP_ADDR_SAME_AS_WHS_ADDR;
        	  let formId = $('#MemberAddressBookForm');
              let addressField = '#address1'; 
          	  COSTCO.dialog.sameAddressValidation(formId, addressField);
            }
          console.error(data.errorMessages[i]);
          errorHtml += i === len - 1 ?
            `<span>${data.errorMessages[i]}</span>` :
            `<p>${data.errorMessages[i]}</p>`;
          if (data.errorMessages[0] == 'APPLICATION_ORDER_ITEM_ID_MISSING') {
        	  let appType = $('#applicationType').val();
              // Stale browser
      	  	  if (appType === 'BD'){
      	  		  window.location.href = '/CheckoutCartView';
      	  		  return;
      	  	  }
          }  
        };
        $selectors.removeClass('hide').append(errorHtml);
        $('html, body').scrollToElem($selectors, 100);
      } else {
        $selectors.removeClass('critical-notification');
        // Clear previous error on success (needed on Add People Outside Renewal page)
        COSTCO.util.notification.clearNotification();
      }
      return data;
    },
    /**
     * A wrapper around membershipData. We use this so we dont need to
     * include membershipData everywhere
     * @return {Object} The object from sessionStorage representing the
     *                      configProduct application metadata
     */
    getConfigProduct: function() {
      return membershipData.getConfigProduct();
    },
    /**
     * A wrapper around membershipData. We use this so we dont need to
     * include membershipData everywhere
     * @param  {Object} data The object (represetning the membership application
     *                       metadata) to set in sessionStorage.
     * @return {Object}      Returns the same data object passed as an argument
     *                               (meant to be a chainable action)
     */
    setConfigProduct: function(data) {
      return membershipData.setConfigProduct(data);
    },
    /**
     * Pull a specific address by label from an array of addresses. For example
     * 'Primary' in theory return the primary address if it matches the label.
     * @param  {[type]} addressLabel [description]
     * @param  {[type]} addressArray [description]
     * @return {[type]}              [description]
     */
    findAddressByLabel: function(addressLabel, addressArray) {
      let address = {};
      $(addressArray).each(function(index, value) {
        if (value.label == addressLabel) {
          address = value;
          return false;
        }
      });
      return address;
    },
    /**
     * Returns a chainable address verification object. Right now this
     * is specific to the membership application. Maybe parameterize this
     * to accept a specific form and selectors.
     * @param {Object} selectors The object that contains selectors
     * @return {jQuery.Deferred} Returns a deferred, thenable object.
     */
    verifyAddresses: function(selectors) {
      let addressObjects = this.buildAddressArray($(selectors.form), {
        primary: selectors.primary,
        business: selectors.business,
      });
      $('.order-ajax').addClass('ajax-busy');
      return COSTCO.util.ajax({
        url: '/AjaxAddressVerificationCmd',
        type: 'POST',
        dataType: 'json',
        timeout: 15000,
        // Turn off glboal event handlers. ajaxComplete and ajaxError are
        // global events defined in global.js
        global: false,
        data: {
          formdata: encodeURIComponent(JSON.stringify(addressObjects)),
        },
        always: function() {
          $('.permanent-ajax-busy').removeClass('ajax-busy');
        },
        complete: () => {},
      });
    },
    /**
     * [description]
     * @param  {[type]} form [description]
     * @param  {[type]} obj  [description]
     * @return {[type]}      [description]
     */
    buildAddressArray: function(form, obj) {
      let addressObjects = [];
      let primaryAVSObj = addressVerification.buildRequestElement(form, obj.primary);
      if(typeof primaryAVSObj.fName == 'undefined' || primaryAVSObj.fName == ''){
    	  primaryAVSObj.fName = $("#MemberAddressBookForm input[name='first_name']").val();
    	  primaryAVSObj.lName = $("#MemberAddressBookForm input[name='lastName']").val();
      }
      addressObjects.push(primaryAVSObj);
      if (this.isBusinessMembership() && obj.business) {
        let businessAVSObj = addressVerification.buildRequestElement(form, obj.business);
        if(typeof businessAVSObj.fName == 'undefined' || businessAVSObj.fName == ''){
	        businessAVSObj.fName = $("#MemberAddressBookForm input[name='first_name']").val();
	        businessAVSObj.lName = $("#MemberAddressBookForm input[name='lastName']").val();
        }
        addressObjects.push(businessAVSObj);
      }
      $.each(addressObjects, function(index, value) {
        if (value.id == '') {
          addressObjects[index].id = index;
        }
      });
      return addressObjects;
    },
    /**
     * This function serves as an intermediary to invoking the verification
     * modal. It prepares data appropriately and then invokes. If the verification
     * response has all "no suggestions", we simply invoke the callback on the
     * entered addresses.
     * @param  {Object}   addressObj The response from calling
     *                               /AjaxAddressVerificationCmd. The data
     *                               structure looks like
     *                                {Address:[], Validated_Address: []}
     * @param  {Function} callback   The function which ends up being the
     *                               primary event on the verification modal.
     *                               It could submit a form, etc.
     * @return {void}
     */
    invokeMultiAVS: function(addressObj, callback) {
      $('.order-ajax').removeClass('ajax-busy');
      if (typeof addressObj !== 'undefined' && addressObj != null && addressObj.Validated_Address != null) {
	      let multiAVSModal = addressVerification.showMultiAddressVerificationModal;
	
	      if (addressVerification.hasAllNoSuggestion(addressObj.Validated_Address)) {
	        // In this case we just want to use the user inputted addresses
	        callback(addressObj.Address);
	        COSTCO.dialog.close();
	      } else if (addressVerification.hasAllSameAsSuggested(addressObj)) {
	        // Prefering the validate_address as it will contain the 4 digits
	        // appended to the zip code.
	        callback(addressObj.Validated_Address);
	        COSTCO.dialog.close();
	      } else {
	        // We have at least one suggested address. We want to show the modal.
	        let validAddresses = MembershipHelper.removeValidAddressFromArray(addressObj);
	        multiAVSModal(validAddresses, callback);
	      }
      }else {
	    	elementObj = $('[name='+addressObj.errorMessageParam[0]+']');
			if (elementObj.length > 0 ) {
				elementObj.parent().addClass('error');
				elementObj.attr('hasvalidationerror', true);
				$(elementObj).parent().parents("form:first").valid();
	    	}
		}
    },
    /**
     * This function populates a given form. Its meant to replace the values
     * of each designated field with what the addresses selected after the
     * verification process. We then can just serialize the form to send to the
     * backend.
     * @param  {jQuery} form        The form to populate
     * @param  {Array} addresses    Array of validated addresses to get address
     *                              details from it and send with membership
     *                              application form.
     * @param  {boolean} isAffiliate Are we populating the affiliate form?
     * @return {void}
     */
    populateAddressData: function(form, addresses, isAffiliate) {
      let primaryAddress = isAffiliate ?
        this.findAddressByLabel('Affiliate Address', addresses) :
        this.findAddressByLabel('Primary Address', addresses);
      form.find('input[name=address1],input[name=line1]').val(primaryAddress.line1 != null? primaryAddress.line1.trim(): "");
      form.find('input[name=address2],input[name=line2]').val(primaryAddress.line2);
      form.find('input[name=city]').val(primaryAddress.city);
      form.find('select[name=state]').val(primaryAddress.state);
      form.find('input[name=postalcode],input[name=zip]').val(primaryAddress.zip);
      form.find('input[name=country]').val(primaryAddress.country);
      if (this.isBusinessMembership() && !isAffiliate) {
        let businessAddress = this.findAddressByLabel('Business Address', addresses);
        form.find('input[name=businessAddressLine1]').val(businessAddress.line1);
        form.find('input[name=businessAddressLine2]').val(businessAddress.line2);
        form.find('input[name=businessCity]').val(businessAddress.city);
        form.find('select[name=businessState]').val(businessAddress.state);
        form.find('input[name=businessZipCode]').val(businessAddress.zip);
        form.find('input[name=businessCountry]').val(businessAddress.country);
      }
    },
    /**
     * Removes valid addresses from he AVS response array
     * @param  {Array} addressObj AVS address array
     * @return {Array} Array of addresses to be validated
     */
    removeValidAddressFromArray: function(addressObj) {
      let addressesToVerify = {
        Address: [],
        Validated_Address: [],
        No_Suggestion: [],
        size: 0,
      };
      $.each(addressObj.Validated_Address, function(indexNew, valueNew) {
        let entered = addressVerification.findAddressById(valueNew.id, addressObj.Address);
        addressesToVerify.Validated_Address.push(addressObj.Validated_Address[indexNew]);
        addressesToVerify.Address.push(entered);
      });
      addressesToVerify.size = addressesToVerify.Address.length;
      return addressesToVerify;
    },
    /**
     * [description]
     * @param  {[type]} stateProvList [description]
     * @return {[type]}               [description]
     */
    getStateOptions: function(stateProvList) {
      return addressForm.getStateOptions(stateProvList);
    },
    /**
     * Make a call to grab the application meta data from
     * the membershipData module.
     * @return {jQuery.Promise} The returned promise to chain
     */
    getApplicationData: function() {
      return membershipData.getApplicationData();
    },
    /**
     * Get the membership meta data from the server
     * @return {jQuery.Promise} The returned promise to chain
     */
    getMembershipData: function() {
      return membershipData.getMembershipData();
    },
    /**
     * [description]
     * @return {[type]} [description]
     */
    getStateProvJson: function() {
      return address.getStateProvJson();
    },
    /**
     * [description]
     * @param  {[type]} x [description]
     * @param  {[type]} y [description]
     * @param  {[type]} z [description]
     * @return {[type]}   [description]
     */
    bingCityState: function(x, y, z) {
      return address.bingCityState(x, y, z);
    },
    geocodeApiCityState: function(x, y, z) {
      return address.geocodeApiCityState(x, y, z);
    },
    /**
     * Builds the existing affiliates block. Provide a template and a target
     * to append the HTML too.
     * @param  {[type]} template [description]
     * @param  {[type]} target   [description]
     * @return {void}
     */
    buildExistingAffiliates: function(template, target) {
      $('.affiliate-block, .affiliate-clearfix').remove();
      let affiliateHtml = '';

      this.getAffiliates().forEach((affiliate, i) => {
        affiliateHtml += COSTCO.util.tmpl(template, {
          affiliate: affiliate,
          // Needed to inject clearfix where ever needed
          index: i + 1,
        });
      });
      $(target).prepend(affiliateHtml);
    },
    /**
     * Gets the array of affiliates attached to the configProduct
     * @return {Array} The array of objects representing the affiliates
     */
    getAffiliates: function() {
      let affiliates = [];
      let c = this.getConfigProduct();
      if (!$.isEmptyObject(c) && c.affilatedMemberships &&
        c.affilatedMemberships.affilatedMember) {
        affiliates = c.affilatedMemberships.affilatedMember.map((affiliate) => {
          // These fields are used by MemberApplicationAffiliateUpdateCmd
          // Some of them are duplicates of whats already defined
          // on configProduct.affilatedMemberships.affilatedMember because
          // theres no standard
          affiliate.affiliateMembershipNumber = affiliate.membershipNumber || '';
          affiliate.parentMembershipNumber = c.membershipNumber || '';
          affiliate.organizationId = c.organizationId || '';
          affiliate.first = affiliate.firstName || '';
          affiliate.last = affiliate.lastName || '';
          affiliate.mi = affiliate.mi || '';
          return affiliate;
        });
      }
      return affiliates;
    },
    /**
     * Using the AllMembershipInfoDataBean as the source of data, locate the
     * specific affiliate by number
     * @param  {Object} data   The AllMembershipInfoDataBean serielized
     *                         as a JS object
     * @param  {Number} number The affiliate membership number
     * @return {Object}        The JS object representing the affiliate from
     *                             AllMembershipInfoDataBean
     */
    getAffiliateFromDataBeanByNumber(data, number) {
      let affiliate = undefined;
      if (data.caller &&
        data.caller.businessInfo &&
        data.caller.businessInfo.affiliates) {
        let affiliates = data.caller.businessInfo.affiliates;
        affiliates.forEach((aff) => {
          if (aff.cardNumber &&
            aff.cardNumber.value &&
            aff.cardNumber.value == number) {
            affiliate = aff;
          }
        });
      }
      return affiliate;
    },
    /**
     * Gets the affiliate object from the configProduct if one exists.
     * @param  {Number} membershipNumber The affiliate membershipNumber
     * @return {Object}                  The affiliate object
     */
    getAffiliateByNumber(membershipNumber) {
      let affiliate = undefined;
      this.getAffiliates().forEach((aff) => {
        if (membershipNumber == aff.membershipNumber) {
          affiliate = aff;
          return;
        }
      });
      return affiliate;
    },
    /**
     * Gets the affiliate household from the configProduct if one exists
     * @param  {Number} membershipNumber The affiliate household membership number
     * @return {Object}                  The affiliate household object
     */
    getAffiliateHouseholdByNumber(membershipNumber) {
      let affHousehold = undefined;
      this.getAffiliates().forEach((aff) => {
        if (aff.houseHold && aff.houseHold.membershipNumber == membershipNumber) {
          affHousehold = aff.houseHold;
          return;
        }
      });
      return affHousehold;
    },
    /**
     * Gets the affiliate object using the affiliate's household membership number.
     * @param  {Number} membershipNumber The affiliate household membership number
     * @return {Object}                  The affiliate object
     */
    getAffiliateByHouseholdNumber(membershipNumber) {
      let affiliate = undefined;
      this.getAffiliates().forEach((aff) => {
        if (aff.houseHold && aff.houseHold.membershipNumber == membershipNumber) {
          affiliate = aff;
          return;
        }
      });
      return affiliate;
    },
    /**
     * Gets the affiliate object using the affiliate's household membership number.
     * @param  {Object} data   The AllMembershipInfoDataBean serielized
     *                         as a JS object
     * @param  {Number} membershipNumber The affiliate household membership number
     * @return {Object}                  The affiliate object
     */
    getAffByHouseholdNumber(data, membershipNumber) {
      let affiliate = undefined;
      if (data.caller &&
        data.caller.businessInfo &&
        data.caller.businessInfo.affiliates) {
        let affiliates = data.caller.businessInfo.affiliates;
        affiliates.forEach((aff) => {
          if (aff.household && aff.household.cardNumber && aff.household.cardNumber.value == membershipNumber) {
            affiliate = aff;
            return;
          }
        });
      }
      return affiliate;
    },
    /**
     * Takes the request data serialized from the affiliate form template
     * (tmpl_affiliate) and transforms it to the appropriate namespace for
     * the MemberAffiliateAddCmd used by renew membership / business
     * details flows.
     * @method
     * @param  {Object} requestData The object representing the form inputs
     *                              from form#affiliate-form
     * @return {Object}             The transformed inputs in an object.
     */
    transformAffiliateInputNames: function(requestData) {
      let newRequestData = {};
      let prefix = 'MembershipCrmAddAffiliate_';
      Object.keys(requestData).forEach((key) => {
        switch (key) {
          case 'fname':
            newRequestData[`${prefix}firstName`] = requestData[key];
            break;
          case 'lname':
            newRequestData[`${prefix}lastName`] = requestData[key];
            break;
          case 'dobday':
            newRequestData[`${prefix}dobEditDay`] = requestData[key];
            break;
          case 'dobmonth':
            newRequestData[`${prefix}dobEditMonth`] = requestData[key];
            break;
          case 'dobyear':
            newRequestData[`${prefix}dobEditYear`] = requestData[key];
            break;
          case 'line1':
            newRequestData[`${prefix}addressLine1`] = requestData[key];
            break;
          case 'line2':
            newRequestData[`${prefix}addressLine2`] = requestData[key];
            break;
          case 'cphone':
            newRequestData[`${prefix}phone`] = requestData[key];
            break;
          case 'mphone':
            newRequestData[`${prefix}mobile`] = requestData[key];
            break;
          case 'householdPrefix':
            newRequestData[`${prefix}household_prefix`] = requestData[key];
            break;
          case 'householdFname':
            newRequestData[`${prefix}household_firstName`] = requestData[key];
            break;
          case 'householdMi':
            newRequestData[`${prefix}household_mi`] = requestData[key];
            break;
          case 'householdLname':
            newRequestData[`${prefix}household_lastName`] = requestData[key];
            break;
          case 'householdSuffix':
            newRequestData[`${prefix}household_suffix`] = requestData[key];
            break;
          case 'householdDobMonth':
            newRequestData[`${prefix}household_dobEditMonth`] = requestData[key];
            break;
          case 'householdDobDay':
            newRequestData[`${prefix}household_dobEditDay`] = requestData[key];
            break;
          case 'householdDobYear':
            newRequestData[`${prefix}household_dobEditYear`] = requestData[key];
            break;
          case 'householdEmail':
            newRequestData[`${prefix}household_email`] = requestData[key];
            break;
          case 'householdPrimaryPhoneNumber':
            newRequestData[`${prefix}household_phone`] = requestData[key];
            break;
          case 'householdCheckbox':
            newRequestData[`${prefix}includeHousehold`] = requestData[key];
            break;
          default:
            newRequestData[`${prefix}${key}`] = requestData[key];
        }
      });
      return newRequestData;
    },
    /**
     * Similar to above method. Take the old input names and transform them to
     * what the backend is expecting (for /MemberHouseholdAddCmd)
     * @param  {Object} requestData The object representing the form inputs
     *                              from form#affiliate-form
     * @return {Object}             The transformed inputs in an object.
     */
    transformAffiliateHouseholdInputNames: function(requestData) {
      let newRequestData = {};
      Object.keys(requestData).forEach((key) => {
        switch (key) {
          case 'householdPrefix':
            newRequestData['prefix'] = requestData[key];
            break;
          case 'householdFname':
            newRequestData['first_name'] = requestData[key];
            break;
          case 'householdMi':
            newRequestData['middle_name'] = requestData[key];
            break;
          case 'householdLname':
            newRequestData['last_name'] = requestData[key];
            break;
          case 'householdSuffix':
            newRequestData['suffix'] = requestData[key];
            break;
          case 'householdDobMonth':
            newRequestData['month'] = requestData[key];
            break;
          case 'householdDobDay':
            newRequestData['day'] = requestData[key];
            break;
          case 'householdDobYear':
            newRequestData['year'] = requestData[key];
            break;
          case 'householdEmail':
            newRequestData['email'] = requestData[key];
            break;
          case 'householdPrimaryPhoneNumber':
            newRequestData['contact_phone'] = requestData[key];
            break;
          default:
            newRequestData[key] = requestData[key];
        }
      });
      return newRequestData;
    },
    /**
     * First show the user the affiliates as registered with their
     * xorderitems.crmmemberinfo (configProduct) on the application page.
     * If they have 6, we don't allow anymore.
     * @param  {[type]} data [description]
     * @return {[type]}      [description]
     */
    reflectAffiliates: function(data) {
      // First show the affiliates returned from submission
      COSTCO.MembershipHelper.buildExistingAffiliates('tmpl_affiliate_block', '#add-person-container');
      // Hide add person button if we're >= 6 affiliates
      COSTCO.AffiliateForm.checkAffiliateNumber(data);
      return data;
    },
    /**
     * Build the affiliate list for renew / account details view using the response
     * from some crud operation.
     * @param  {Object} data The JSON object representing the AllMembershipInfoDataBean
     * @return {Object}      Same as parameter - used for chaining to the next method.
     */
    reflectAffiliatesAlternate: function(data) {
      if (data && data.caller && data.caller.businessInfo && data.caller.businessInfo.affiliates) {
        COSTCO.RenewMembership.membershipData = /* COSTCO.AccountDetails.membershipData = */ data;
        let affiliateHtml = '';
        let affiliates = data.caller.businessInfo.affiliates || [];
        affiliates.length > 0
          // Remove the empty class (if it exists), which has a border-top
          // attribute. The following affiliate blocks have border-tops.
          ?
          $('#affiliate-list-container').removeClass('empty') :
          $('#affiliate-list-container').addClass('empty');
        affiliates.forEach((a) => {
          affiliateHtml += COSTCO.util.tmpl('tmpl_affiliate_row', {
            affiliateCardNumber: a.cardNumber.value,
            affiliateFirstName: a.firstName.value,
            affiliateLastName: a.lastName.value,
            isNewAffiliate: a.statusReasonDesc && a.statusReasonDesc.value == 'Created',
            hasHousehold: a.household && a.household.cardNumber.value,
            affiliateHouseholdNumber: a.household.cardNumber.value,
            affiliateHouseholdFirstName: a.household.firstName.value,
            affiliateHouseholdLastName: a.household.lastName.value,
          });
        });
        $('#affiliate-list-container').html(affiliateHtml);
      }
      return data;
    },
    /**
     * Build the affiliate list for Add Additional People outside renewal view using
     * the response from some crud operation.
     * @param {Object} data The JSON object representing the AllMembershipInfoDataBean.
     * @return {Object} Same as parameter - used for chaining to the next method.
     */
    reflectAffiliatesBussinessOutsideRenewal: function(data) {
      COSTCO.AddAdditionalPeople.membershipData = /* COSTCO.AccountDetails.membershipData = */ data;
      let newAffiliateHtml = '';
      let affiliateHtml = '';
      let affiliates = data.caller.businessInfo.affiliates || [];
      let newAffiliatesCount = 0;
      let individualFee = 0;
      affiliates.forEach((a) => {
        if (a.statusReasonDesc && a.statusReasonDesc.value == 'Created') {
          newAffiliatesCount++;
        }
      });
      let totalFee = parseFloat(data.caller.addAffiliateAmount);
      if (newAffiliatesCount > 0) {
        // Remove the empty class (if it exists), which has a border-top
        // attribute. The following affiliate blocks have border-tops.
        $('#new-people-on-my-membership').removeClass('empty');
        individualFee = totalFee / newAffiliatesCount;
        // Display info message if there are no errors
        if (!$('#notification-message').hasClass('critical-notification')) {
          COSTCO.util.notification.displayNotification(COSTCO.util.notification.type.SUCCESS, [messages.ACCOUNT_RWD__AddAdditionalPeople_AdditionalPersonCost_InfoText]);
        }
      } else {
        $('#new-people-on-my-membership').addClass('empty');
        // Remove info message if there are no errors
        if (!$('#notification-message').hasClass('critical-notification')) {
          COSTCO.util.notification.clearNotification();
        }
      }
      affiliates.forEach((a) => {
        if (a.statusReasonDesc && a.statusReasonDesc.value == 'Created') {
          newAffiliateHtml += COSTCO.util.tmpl('tmpl_add_new_affiliate_row', {
            affiliateCardNumber: a.cardNumber.value,
            affiliateFirstName: a.firstName.value,
            affiliateLastName: a.lastName.value,
            isNewAffiliate: true,
            hasHousehold: a.household && a.household.cardNumber.value,
            affiliateHouseholdNumber: a.household.cardNumber.value,
            affiliateHouseholdFirstName: a.household.firstName.value,
            affiliateHouseholdLastName: a.household.lastName.value,
            individualFeeJS: individualFee.toFixed(2),
          });
        } else {
          affiliateHtml += COSTCO.util.tmpl('tmpl_affiliate_row', {
            affiliateCardNumber: a.cardNumber.value,
            affiliateFirstName: a.firstName.value,
            affiliateLastName: a.lastName.value,
            isNewAffiliate: false,
            hasHousehold: a.household && a.household.cardNumber.value,
            affiliateHouseholdNumber: a.household.cardNumber.value,
            affiliateHouseholdFirstName: a.household.firstName.value,
            affiliateHouseholdLastName: a.household.lastName.value,
          });
        }
      });
      $('#new-people-on-my-membership').html(newAffiliateHtml);
      $('#affiliate-list-container').html(affiliateHtml);
      if (totalFee) {
        $('#total-fee').html('$' + totalFee.toFixed(2));
      }
      // In border cases, when newAffiliatesCount changes from 0 to 1, or from 1 to 0,
      // hide/show appropriate sections to have verbiage in singular/plural, show/hide
      // total cost, and enable/disable Add to Cart button.
      if (newAffiliatesCount == 0) {
        $('#add-a-person-outside-renewal').removeClass('hide');
        $('#add-another-person-outside-renewal').addClass('hide');
        $('#total-price-section').addClass('hide');
        $('#add-to-cart').attr('disabled', 'disabled');
      } else if ((newAffiliatesCount == 1) && ($('#add-another-person-outside-renewal').hasClass('hide'))) {
        $('#add-a-person-outside-renewal').addClass('hide');
        $('#add-another-person-outside-renewal').removeClass('hide');
        $('#total-price-section').removeClass('hide');
        $('#add-to-cart').removeAttr('disabled');
      }
      // Hide the option to add more affiliates if there are more than six
      if (affiliates.length >= 6) {
        $('#add-another-person-outside-renewal').addClass('hide');
      }
      return data;
    },
    /**
     * If the response has affiliates, we want the the link to show
     * "Add Another Person". If we have zero, we want the link to say
     * "Add a Person".
     * @param  {Object} data The JSON object representing the AllMembershipInfoDataBean
     * @return {Object}      Same as parameter - used for chaining to the next method.
     */
    addPersonLink: function(data) {
      if (data && data.caller &&
        data.caller.businessInfo &&
        data.caller.businessInfo.affiliates &&
        data.caller.businessInfo.affiliates.length > 0) {
        $('#add-another-person-text').removeClass('hide');
        $('#add-a-person-text').addClass('hide');
      } else {
        $('#add-another-person-text').addClass('hide');
        $('#add-a-person-text').removeClass('hide');
      }
      return data;
    },
    /**
     * If we already have 6 newly added affiliates, we don't want to allow the
     * user to add any more. This function checks that and then hides/disables
     * the "Add Another Person" link.
     * @param  {Object} data The JSON object representing the AllMembershipInfoDataBean
     * @return {Object}      Same as parameter - used for chaining to the next method.
     */
    canAddAffiliate: function(data) {
      let counter = 0;
      if (data && data.caller && data.caller.businessInfo && data.caller.businessInfo.affiliates) {
        (data.caller.businessInfo.affiliates || []).forEach((a) => {
          if (a.statusReasonDesc && a.statusReasonDesc.value == 'Created') {
            counter++;
          }
        });
        // Handle hide/show of Add Person/Add Another Person
        if (COSTCO.MembershipHelper.isQuickMembership) {
          if (counter == 0) {
            $('#add-a-person-text').removeClass('hide');
            $('#add-another-person-text').addClass('hide');
          } else if (counter > 0 && counter < 6) {
            $('#add-a-person-text').addClass('hide');
            $('#add-another-person-text').removeClass('hide');
          } else {
            $('#add-a-person-text').addClass('hide');
            $('#add-another-person-text').addClass('hide');
          }
        } else if (counter >= 6) {
          $('#add-another-person').addClass('hide');
        } else {
          $('#add-another-person').removeClass('hide');
        }
      }
      return data;
    },
    /**
     * This takes the renewal price from the AllMembershipInfoDataBean
     * (caller.renewAmount) and replaces the value of span#renewal-amount
     * located at MembershipRenewInfo_Business_UI.jspf
     * @param  {Object} data The JSON object representing the AllMembershipInfoDataBean
     * @param  {Boolean} isUpgrade
     * @return {Object}      Same as parameter - used for chaining to the next method.
     */
    updateTotalPrice: function(data, isUpgrade) {
      if (data && data.caller && data.caller.renewAmount) {
        let locale = COSTCO.util.getLocale().substr(0, 2);
        $('#renewal-amount').text(
          COSTCO.util.localeSpecificCurrency(isUpgrade ? data.caller.renewAndUpgradeAmount : data.caller.renewAmount, locale));
      }
      return data;
    },
    /**
     * In Account Details, when a user has a validated profile with a internal
     * card (usage = 'Z050') wants to change their email address, we invalidate
     * them unless they're changing their email that includes the costco domain.
     * (<username>@costco.com)
     * @param  {DOMElement} form The form to pull the profile email from
     * @return {boolean}     Does this profile need to be invalidated?
     */
    isInternalInvalidated: function(form) {
      let email = $(form).find('#update-email').val();
      return COSTCO.util.getMemberCookie().usage == 'Z050' &&
        !(email.includes('@costco.com') || email.includes('@costco.ca'));
    },
	/** Adding zero the left of the input if its lenght is 1 */
	prependZero: function(event){
		let value = $(event.currentTarget).val();
		if (value != null && value != '') {
			if(value.length == 1 && value != '0'){
				value = '0' + value;
			}
			$(event.currentTarget).val(value);  
		}
	},
  };
  if (typeof window.COSTCO == 'undefined') {
    window.COSTCO = {};
  }
  window.COSTCO.MembershipHelper = MembershipHelper;
  return MembershipHelper;
});



// WEBPACK FOOTER //
// ./js/membership/membership-helper.js